import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

export const SOFT_DELETE_USER = gql`
  mutation SoftDeleteUser($id: ID!) {
    softDeleteUser(data: { id: $id }) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
